export const DEFAULT_WEB_FAVICON_URL = "/favicon.ico";

function parseRecord(value) {
  if (typeof value === "string") {
    try {
      return parseRecord(JSON.parse(value));
    } catch {
      return {};
    }
  }

  return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}

function firstUrl(...values) {
  for (const value of values) {
    const url = String(value || "").trim();
    if (url) return url;
  }
  return "";
}

export function resolveShopFaviconUrl(shopInfoValue) {
  const shopInfo = parseRecord(shopInfoValue);
  const followData = parseRecord(shopInfo.offiaccountFollowData);
  const legacyFollowData = parseRecord(shopInfo.offiaccountFollowUrl);
  const otherJson = parseRecord(
    followData.otherJson
    || legacyFollowData.otherJson
    || shopInfo.otherJson
    || parseRecord(shopInfo.storePageInfo).otherJson,
  );
  const mobileBaseConfig = parseRecord(otherJson.mobileBaseConfig);
  const mobileConfig = {
    ...Object.fromEntries(
      Object.entries(mobileBaseConfig).filter(([key]) => !["common", "h5", "app"].includes(key)),
    ),
    ...parseRecord(mobileBaseConfig.common),
    ...parseRecord(mobileBaseConfig.h5),
  };
  const appInfoPage = parseRecord(otherJson.appInfoPage);
  const reactAppConfig = parseRecord(otherJson.reactAppConfig);

  return firstUrl(
    mobileConfig.faviconUrl,
    otherJson.faviconUrl,
    reactAppConfig.faviconUrl,
    appInfoPage.faviconUrl,
    appInfoPage.appLogo,
    mobileConfig.homeIconUrl,
    otherJson.homeIconUrl,
    shopInfo.faviconUrl,
    shopInfo.logoUrl,
    shopInfo.shopLogo,
    shopInfo.logo,
  ) || DEFAULT_WEB_FAVICON_URL;
}
